export const trendClass = (trend) => {
  if (trend === "increased") return "kbv-v26-odds-value--up";
  if (trend === "decreased") return "kbv-v26-odds-value--down";
  return "";
};

export const hasTrend = (trend) => trend === "increased" || trend === "decreased";
